// Small, eagerly-loaded language list. The heavy NL/EN dictionary (TR) lives in
// translations.js and is dynamically imported only when a non-FR language is active.
export const LANGS = [
  { code: "fr", label: "FR", name: "Français" },
  { code: "nl", label: "NL", name: "Nederlands" },
  { code: "en", label: "EN", name: "English" },
];
